<template>
  <DefaultLayout :searchQuery="searchQuery" @update:searchQuery="searchQuery = $event">
    <Hero v-if="!searchQuery" />
    <div class="container-nzidoo">
      <HomeProductsList :randomProducts="randomProducts" :search-query="searchQuery" />
    </div>
  </DefaultLayout>
</template>

<script>
import Hero from "@/components/home/Hero.vue";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import config from "@/config";
import HomeProductsList from "@/components/home/HomeProductsList.vue";
import cookieUtils from "@/services/cookieUtils";

export default {
  data() {
    return {
      firstCategory: [],
      firstSubCategory: [],
      secondCategory: [],
      secondSubCategory: [],
      itemToShowFirst: 0,
      productOfTheWeak: [],
      itemToShowSecond: 0,
      storageUrl: config.storageUrl,
      randomProducts: [],
      hasBeenSoldProducts: [],
      emptyProduct: true,
      searchQuery: (this.$route && this.$route.query && this.$route.query.search) || '',
    };
  },
  beforeMount() {   
    this.getRandomProducts(200, 0);
  },
  watch: {
    '$route.query.search'(newVal) {
      this.searchQuery = newVal || '';
    },
  },
  mounted() {
    this.$forceUpdate();
  },
  components: {
    DefaultLayout,
    Hero,
    HomeProductsList,
  },
  computed: {
    parentCategories() {
      return this.categories.categories !== undefined
        ? this.categories.categories.filter((i) => i.parent_id == 0)
        : null;
    },
    categories: {
      get() {
        return this.$store.state.categories;
      },
      set(categories) {
        this.$store.commit("categories", { attributes: categories });
      },
    },
  },
  methods: {
    pickRandomly(parentCategories) {
      var arr = [];
      var categories = [];
      while (arr.length < 3) {
        var r = Math.floor(Math.random() * parentCategories.length) + 1;
        if (arr.indexOf(r) === -1) {
          arr.push(r);
          categories.push(parentCategories[r - 1]);
        }
      }
      return categories;
    },
    loadMore() {
      if (
        this.searchComponentFilter !== undefined &&
        this.searchComponentFilter.length > 0
      ) {
        this.getProductWithFilters(this.searchComponentFilter);
        return;
      }
    },
    
    getRandomProducts(number, hasBeenSold) {
      var self = this;
      
      // Get user's preferred categories from cookies
      const preferredCategories = cookieUtils.getTopCategories(5);
      const preferredSalesTypes = cookieUtils.getPreferredSalesTypes();
      
      // Build request parameters
      let params = {
        limit: number,
        has_been_sold: hasBeenSold
      };
      
      // Add preferred categories if available
      if (preferredCategories.length > 0) {
        params.preferred_categories = preferredCategories.join(',');
      }
      
      // Add preferred sales types if available
      if (preferredSalesTypes.length > 0) {
        params.preferred_sales_types = preferredSalesTypes.join(',');
      }
      
      this.$axios({
        url: "product/list/random/" + number + "/" + hasBeenSold,
        method: "GET",
        params: params
      })
        .then((response) => {
          if (hasBeenSold === 1) {
            self.hasBeenSoldProducts = response.data;
          }

          if (hasBeenSold === 0) {
            self.randomProducts = response.data;
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },

    subCategories(categoryId) {
      return this.categories.filter(
        (i) => i.parent_id != 0 && categoryId == i.parent_id
      );
    },
  },
};
</script>

<style></style>